module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-06-4bc01a1b7b4ef901d34176bbc8669436.jpg";